﻿import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { userAware } from 'components/UserProvider';
import Modal from 'components/Modal';
import Button from 'components/Button';
import ButtonLink from 'components/ButtonLink';
import Loader from 'components/Loader';

import { mapModalDispatchToProps } from 'helpers/redux';

import theme from "./ConfirmPlanModal.module.sass";

export const CONFIRM_MAINTENANCE_PLAN_MODAL_ID =
  'MaintenancePlan/CONFIRM_MODAL';

// The plan is sold on the Shopify store. This used to be the API's `checkout_url`
// plus `&auth_email=`, a WooCommerce checkout on www.naturalacneclinic.com that no
// longer exists. CLEAR FOR A YEAR is the only plan the page offers.
export const MAINTENANCE_PLAN_CHECKOUT_URL =
  'https://shop.naturalskincareclinic.com/products/clear-for-a-year-maintenance-plan';

// This URL has no query string, so a literal `&auth_email=` would land in the path and
// Shopify answers 404. searchParams also encodes the email: a raw `+`, as in every
// pst+ QA address, would otherwise be read back as a space.
export const checkoutUrlFor = (email) => {
  const url = new URL(MAINTENANCE_PLAN_CHECKOUT_URL);
  url.searchParams.set('auth_email', email);
  return url.toString();
};

const ConfirmPlanModal = ({
  user,
  plan,
  submitting = false,
  onConfirm,
  setOpenModalId,
}) => (
  <Modal
    id={CONFIRM_MAINTENANCE_PLAN_MODAL_ID}
    title="Confirmation"
    size="small"
  >
    <div className={theme.ConfirmPlanModal}>
      <h1>Before going further, make sure your selection is correct</h1>
      <p>Selected Plan: {plan.name}</p>
      <footer>
        {submitting && <Loader type="absolute" />}
        <Button
          disabled={submitting}
          size="big"
          onClick={() => {
            setOpenModalId(null);
          }}
          color="secondary"
        >
          Cancel
        </Button>
        <ButtonLink
          href={checkoutUrlFor(user.email)}
          target="_blank"
          rel="noopener noreferrer"
          disabled={submitting}
          size="big"
          onClick={() => {
            onConfirm(plan);
          }}
        >
          Confirm
        </ButtonLink>
      </footer>
    </div>
  </Modal>
);

ConfirmPlanModal.propTypes = {
  user: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  setOpenModalId: PropTypes.func.isRequired,
};

const mapStateToProps = ({ modal }) => ({
  plan: modal.modalProps.plan || {},
});

export default connect(
  mapStateToProps,
  mapModalDispatchToProps,
)(userAware(ConfirmPlanModal));
